import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { migraPasoDel } from "services/services-mia/migra";

export default function DeleteModal({ updateList, paso, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await migraPasoDel(
            { migraPasoId: paso.id },
            credentials
        );

        handleResponse(response, "Paso eliminado exitosamente", {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        });

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                migraPasoNombre: paso.migraPasoNombre,
            }}
            validationSchema={yup.object({
                migraPasoNombre: yup
                    .string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required),
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="migraPasoNombre"
                        labelText="Paso"
                        disabled
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
